export default function isMobile() {
    return window.innerWidth < window.innerHeight 
        ? window.innerWidth < 600
        : window.innerWidth < 960 && window.innerHeight < 450;
}

export function isMobilePortrait() {
    return window.innerWidth < window.innerHeight && window.matchMedia("(max-width: 600px)").matches
}